<div class="flex flex-col min-h-screen app-shell-root" [class.app-shell--map]="shellLayout === 'map'">
  <a class="skip-link" href="#main-content">Salta al contenuto principale</a>

  <dpac-cookie-consent
    [open]="showCookiePreferences()"
    [footerInView]="footerInView()"
    [statisticsServices]="statisticsServices"
    (closed)="onCookieConsentClosed()"
    (cookiePolicyRequested)="navigateToCookiePolicy()"
    (privacyPolicyRequested)="navigateToPrivacyPolicy()"
  />

  <!-- CONTACT FORM MODAL OVERLAY -->
  @if (showContactModal()) {
    <div class="z-50 fixed inset-0 flex justify-center items-center bg-black/50 p-4 privacy-modal-overlay">
      <app-contact-request-modal (closed)="showContactModal.set(false)"></app-contact-request-modal>
    </div>
  }

  <!-- NAVBAR -->
  <header class="app-shell-header" role="banner">
    <app-navbar [logoUpperBar]="logoUpperBar" [navItems]="navItems()" [logoNavbar]="logoNavbar" [logoLinkedin]="logoLinkedin">
    </app-navbar>
  </header>

  <!-- Mobile menu full-screen: fuori dall'header sticky per evitare conflitti di z-index -->
  @if (mobileMenuOpen()) {
    <div class="mobile-nav-overlay" role="dialog" aria-modal="true" aria-label="Menu di navigazione">
      <div class="mobile-nav-overlay__header">
        <button
          type="button"
          class="mobile-nav-close"
          aria-label="Chiudi menu"
          (click)="closeMobileMenu()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
            <path d="m13.06 12 6.47-6.47-1.06-1.06L12 10.94 5.53 4.47 4.47 5.53 10.94 12l-6.47 6.47 1.06 1.06L12 13.06l6.47 6.47 1.06-1.06L13.06 12Z" />
          </svg>
        </button>
      </div>

      <nav class="mobile-nav-overlay__nav" aria-label="Navigazione mobile">
        <ul class="mobile-nav-overlay__list">
          @for (item of visibleNavItems(); track item.path) {
            <li>
              <a
                class="mobile-nav-overlay__link"
                [routerLink]="item.path"
                routerLinkActive="mobile-nav-overlay__link--active"
                [routerLinkActiveOptions]="{ exact: item.exact === true }"
                (click)="closeMobileMenu()"
              >
                {{ item.label }}
              </a>
            </li>
          }

          @if (!isAuthenticated()) {
            <li>
              <a class="mobile-nav-overlay__link" routerLink="/register" (click)="closeMobileMenu()">
                Registrati
              </a>
            </li>
            <li>
              <button type="button" class="mobile-nav-overlay__link mobile-nav-overlay__action" (click)="mobileLogin()">
                Accedi
              </button>
            </li>
          } @else {
            @if (isIamOnlyUser()) {
              <li>
                <a class="mobile-nav-overlay__link" routerLink="/register" (click)="closeMobileMenu()">
                  Completa il tuo profilo
                </a>
              </li>
            }
            <li>
              <button type="button" class="mobile-nav-overlay__link mobile-nav-overlay__action" (click)="mobileLogout()">
                Logout
              </button>
            </li>
          }
        </ul>
      </nav>
    </div>
  }

  <!-- MAIN -->
  <main
    id="main-content"
    role="main"
    tabindex="-1"
    [attr.aria-label]="shellLayout === 'map' ? 'Mappa e ricerca delle collezioni digitali' : 'Contenuto principale'"
    [class]="shellLayout === 'default' ? 'w-full grow flex flex-col items-center py-3 md:py-4' : 'w-full grow'"
    [class.app-shell-main--map]="shellLayout === 'map'"
    class="grow">

    <div
      [class]="shellLayout === 'default' ? 'mx-auto w-[min(1280px,100%_-_2rem)]' : shellLayout === 'landing' ? 'w-full' : 'w-full h-full'"
      [class.app-shell-main-inner--map]="shellLayout === 'map'">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- FOOTER: landmark contentinfo anche in layout mappa (visivamente nascosto, presente per a11y) -->
  @if (shellLayout === 'map') {
    <footer class="sr-only" role="contentinfo">
      <p>Mappa del patrimonio — Ministero della Cultura / Ecomic</p>
      <nav aria-label="Link di servizio">
        <ul>
          @for (item of footerNavItems(); track item.path) {
            <li><a [routerLink]="item.path">{{ item.label }}</a></li>
          }
          <li><a routerLink="/privacy-policy">Privacy policy</a></li>
          <li><a routerLink="/cookie-policy">Cookie policy</a></li>
        </ul>
      </nav>
    </footer>
  } @else {
    <app-footer [appLogo]="logoFooterWordmark" [appLogo2x]="logoFooterWordmark2x" [appLogoLink]="appLogoLink" [logoFooter]="logoFooter" [logoColLeft1]="logoColLeft1" [logoColLeft2]="logoColLeft2" [logoColLeft3]="logoColLeft3" [logoColLeft4]="logoColLeft4" [logoColRight]="logoColRight" [logoColLeft1Link]="logoColLeft1Link" [logoColLeft2Link]="logoColLeft2Link" [logoColLeft3Link]="logoColLeft3Link" [logoColLeft4Link]="logoColLeft4Link" [logoColRightLink]="logoColRightLink" [navItems]="footerNavItems()" [showBackToTop]="showFooterBackToTop()" (openCookiePreferences)="openCookiePreferences()"></app-footer>
  }
</div>
